<fgb-mobile-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'"></fgb-mobile-page-header>

<div class="banner d-lg-flex d-none" role="banner">
  <h1>{{ 'challenges.page.title' | translate }}</h1>
</div>

<!-- The mobile header shows the title as an h4, so mobile keeps a hidden h1 for screen readers -->
<h1 class="accessibility-only d-lg-none">{{ 'challenges.page.title' | translate }}</h1>

<fgbcl-scorecards-v2-hero-list></fgbcl-scorecards-v2-hero-list>

<!-- Page sub nav (mobile only) -->
<div class="page-tab-nav d-flex d-lg-none" role="tablist">
  <button
    class="page-tab"
    type="button"
    role="tab"
    [class.active]="activeMobileTab === 'challenges'"
    [attr.aria-selected]="activeMobileTab === 'challenges'"
    (click)="onPageTabChange('challenges')"
  >
    {{ 'nav.challenges' | translate }}
  </button>
  <button
    class="page-tab"
    type="button"
    role="tab"
    [class.active]="activeMobileTab === 'badges'"
    [attr.aria-selected]="activeMobileTab === 'badges'"
    (click)="onPageTabChange('badges')"
  >
    {{ 'nav.badges' | translate }}
  </button>
</div>

<div class="content-fold">
  <div class="container pt-3">
    <div class="row g-3 align-items-start">
      <!-- On mobile only the selected page tab's column shows; d-lg-block keeps both columns on desktop -->
      <div class="col-lg-5 d-lg-block" [class.d-none]="activeMobileTab !== 'badges'">
        <fgbcl-scorecards-v2-badges class="d-block"></fgbcl-scorecards-v2-badges>
      </div>
      <div class="col-lg-7 d-lg-block" [class.d-none]="activeMobileTab !== 'challenges'">
        <fgb-scorecards-v2-sub-nav (tabChange)="onTabChange($event)"></fgb-scorecards-v2-sub-nav>

        <!-- Active tab -->
        <ng-container *ngIf="activeTab === 'active'">
          <ng-container *ngIf="activeScorecardGroups$ | async as activeGroups">
            <fgbcl-scorecards-v2-cards
              *ngFor="let group of activeGroups; let i = index"
              [scorecard]="group.parent"
              [linkedChild]="group.child"
              class="d-block mb-3 animate-in"
              [ngClass]="'delay-' + (i < 6 ? i + 1 : 6)"
            ></fgbcl-scorecards-v2-cards>
            <ng-container
              *ngIf="isLoaded() && activeGroups.length === 0"
              [ngTemplateOutlet]="noScorecards"
              [ngTemplateOutletContext]="{ key: 'scorecards.placeholder.description' }"
            ></ng-container>
          </ng-container>
        </ng-container>

        <!-- Completed tab -->
        <ng-container *ngIf="activeTab === 'completed'">
          <ng-container *ngIf="completedScorecards$ | async as completedScorecards">
            <fgbcl-scorecards-v2-cards
              *ngFor="let scorecard of completedScorecards; let i = index"
              [scorecard]="scorecard"
              class="d-block mb-3 animate-in"
              [ngClass]="'delay-' + (i < 6 ? i + 1 : 6)"
            ></fgbcl-scorecards-v2-cards>
            <ng-container
              *ngIf="isLoaded() && completedScorecards.length === 0"
              [ngTemplateOutlet]="noScorecards"
              [ngTemplateOutletContext]="{ key: 'scorecards.completed.placeholder.description' }"
            ></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Empty state, same markup and library classes as the V1 scorecard list placeholder -->
<ng-template #noScorecards let-key="key">
  <div class="challenges-placeholder mb-3" role="status">
    <div class="no-items m-0 no-results-placeholder-div">
      <div class="svg ms-auto me-auto" fgbAnimateSvg>
        <img [src]="'placeholders/challenges.svg' | contentAssetImage" alt="" />
      </div>
      <div class="no-results-placeholder">{{ key | translate }}</div>
    </div>
  </div>
</ng-template>
